<div
  class="wrapper"
  [class.wrapper-blogger-card]="bankDetailsDialogData()?.fromBloggerProfile"
>
  @if (isBankDetailsFormValid()) {
    @if (bankDetailsDialogData()?.fromBloggerProfile) {
      <div class="bank-details-container">
        <mat-accordion [multi]="true">
          @for (bankDetails of bankDetailsFormGroups(); track $index) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Контрагент: {{ bankDetails.get('partner')?.value }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div
                class="form-container"
                app-bank-details-form
                [formGroup]="bankDetails"
                [bankDetailsData]="bankDetailsData()[$index]"
                [bankDetailsDialogData]="bankDetailsDialogData()"
                [legalEntityTypes]="legalEntityTypes()"
                [currentBankDetailsIndex]="$index"
                [isEditModeActive]="isEditModeActive()"
                (handleRecordUpdate)="handleRecordUpdate($event, $index)"
                (deleteBankDetailsClick)="handleDeleteOrUnbind($event)"
              ></div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    } @else {
      <div class="bank-details-unbind">
        <app-action-dropdown-menu
          [actionsList]="['UNBIND_BANK_DETAILS']"
          (actionSelected)="handleDeleteOrUnbind()"
        />
      </div>
      <div
        app-bank-details-form
        [formGroup]="bankDetailsFormGroups()[0]"
        [bankDetailsData]="bankDetailsData()[0]"
        [bankDetailsDialogData]="bankDetailsDialogData()"
        [legalEntityTypes]="legalEntityTypes()"
        [isEditModeActive]="isEditModeActive()"
        (handleRecordUpdate)="handleRecordUpdate($event, 0)"
      ></div>
    }
  } @else {
    <app-loader/>
  }
</div>
<div class="buttons-container">
  <button
    mat-button
    color="primary"
    (click)="closeDialog.emit('cancel')"
  >
    Закрыть
  </button>
</div>
